import { getIntegrationDetails } from 'components/Previews/getIntegrationDetails'
import Styles from './InstagramChrome.module.scss'
import { PlatformChromeProps } from './Types'
import { Avatar } from './Avatar'

export const InstagramChrome = ({ children, integration, caption }: PlatformChromeProps) => {
  const { picture, username } = getIntegrationDetails(integration)

  return (
    <div className={Styles.chrome}>
      <div className={Styles.header}>
        <Avatar picture={picture} className={Styles.avatar} /> {username}
      </div>
      {children}
      <div className={Styles.footer}>
        <div className={Styles.caption}>
          <span className={Styles.username}>{username}</span>
          <span dangerouslySetInnerHTML={{ __html: caption || '' }} />
        </div>
      </div>
    </div>
  )
}
